module.exports = __webpack_public_path__ + "static/media/statements.5dcc8535.svg";